'use strict';

import { Entity } from '../Entity';

export class UserFlowStage extends Entity {
  protected id;

  protected userFlow;

  protected name;

  protected color;

  protected icon;

  protected sortOrder;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.userFlow = data.userFlow;

    this.name = data.name;

    this.color = data.color;

    this.icon = data.icon;

    this.sortOrder = data.sortOrder;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getUserFlow() {
    return this.userFlow;
  }

  public setUserFlow(userFlow) {
    this.userFlow = userFlow;

    return this;
  }

  public getName() {
    return this.name;
  }

  public setName(name) {
    this.name = name;

    return this;
  }

  public getSortOrder() {
    return this.sortOrder;
  }

  public setSortOrder(sortOrder) {
    this.sortOrder = sortOrder;

    return this;
  }

  public getColor() {
    return this.color;
  }

  public setColor(color) {
    this.color = color;

    return this;
  }

  public getIcon() {
    return this.icon;
  }

  public setIcon(icon) {
    this.icon = icon;

    return this;
  }
}
